import { useEffect } from "react";

interface CanonicalTagProps {
  path: string;
}

const CanonicalTag: React.FC<CanonicalTagProps> = ({ path }) => {
  useEffect(() => {
    // Ensure trailing slash for consistency with sitemap (except homepage)
    const normalizedPath = path === '/' ? '/' : (path.endsWith('/') ? path : `${path}/`);
    const canonicalUrl = `https://www.spharaka.com${normalizedPath}`;
    
    // Remove existing canonical tag if present
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }
    
    // Create and add new canonical tag
    const link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canonicalUrl);
    document.head.appendChild(link);
    
    // Cleanup function
    return () => {
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        canonical.remove();
      }
    };
  }, [path]);
  
  return null;
};

export default CanonicalTag;
